import DataContext from "../contexts/DataContext";
import { useContext } from "react";

const useData = () => useContext(DataContext);

export default useData;
